import { Fragment, useState } from "react";
import { Tab } from "@headlessui/react";
import downArrow from "src/assets/arrow-down.svg";
import moment from "moment";
import { Button } from "src/components";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import classNames from "classnames";
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import OrderStatusTooltip from "../../OrderDetailsTab/OrderStatusTooltip";
import PoGeneration from "./PoGeneration";
import Reconcilliation from "./Reconcilliation";
import CNAdvice from "./CNAdvice";
import { searchProduct } from "src/services/invoice-api"; //M10-14632

const category = ["Order", "Invoice", "PO Generation", "CN Advice", "Replenishment"];

const OrderInfoInvoiceProducts = ({ order, product, index, cd, item_code }: { order: any; product: any; index: number; cd: string; item_code: string }) => {
  const [isExpanded, setIsExpanded] = useState(index === 0);

  const [isVersioningModalOpen, setIsVersioningModalOpen] = useState<boolean>(false);
  const [versioningOrderId, setVersioningOrderId] = useState<number>();


  const orderedQty = product?.quantity;
  const remainingQty = product?.remaining_quantity;
  const free_quantity = product?.free_quantity || 0;
  const remainingFreeQty = product?.remaining_free_quantity || 0

  let derivedOrderStatusId = -1;
  let derivedOrderStatusText = "";

  if (remainingQty === orderedQty && remainingFreeQty === free_quantity) {
    derivedOrderStatusText = "Yet to Process";
    derivedOrderStatusId = 1;
  } else if (remainingQty === 0 && remainingFreeQty === 0) {
    derivedOrderStatusText = "Fully Invoiced";
    derivedOrderStatusId = 3;
  } else {
    derivedOrderStatusText = "Partially Invoiced";
    derivedOrderStatusId = 2;
  }

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const refVersioning = useOutsideClick(() => {
    setIsVersioningModalOpen(false);
    setVersioningOrderId(undefined);
  });

  const groupedInvoices = product?.invoiceProductMappings?.reduce((acc: any, item: any) => {
    const invoiceNo = item?.invoiceProduct?.invoice?.invoice_number;
    if (!acc[invoiceNo]) acc[invoiceNo] = [];
    acc[invoiceNo].push(item);
    return acc;
  }, {});

  return (
    <Fragment>
      {isVersioningModalOpen && (
        <div ref={refVersioning} className="px-3">
          <VersioningCrate orderId={versioningOrderId} type="Order" />
        </div>
      )}

      <div>
        <div className="w-full mt-6 mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-6 bg-white" key={index}>
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-2">
              <h3 className="font-semibold text-[1.2rem] flex items-center gap-2">
                {/* M10-14632 */}
                {product?.product_name}{" "}
                <p className="text-[1rem]">
                  (
                  <span
                    className="text-[#7F56D9] cursor-pointer hover:underline"
                    onClick={async () => {
                      try {
                        const res = await searchProduct({
                          search: product?.item_code,
                          page: 1,
                          perPage: 10,
                          company_code: order?.company_code,
                        });
                        const matched = res?.data?.data?.find((p: any) => p.item_code === product?.item_code);
                        if (matched?.company_productcode) {
                          window.sessionStorage.setItem("detailsId", String(matched.company_productcode));
                          window.sessionStorage.setItem("product_activeStatus", matched.active_status ?? "");
                          window.open("/masters/products/details", "_blank");
                        }
                      } catch (e) {
                        console.error(e);
                      }
                    }}
                  >
                    {product?.item_code}
                  </span>
                  )
                </p>
                {/* M10-14632 */}
                {/* <p className="text-[.9rem] font-normal mx-4">
                  Order Qty.{" "}
                  <span className="">
                    {product?.quantity}
                    {product?.free_quantity && +product?.free_quantity}
                  </span>
                </p> */}
                <span className="border border-[#E4E4E6] rounded-lg px-2 py-1 text-[.8rem]">CD : {cd}%</span>
              </h3>
              <div className="flex items-center gap-2 mt-2">
                <OrderStatusTooltip orderStatusCode={derivedOrderStatusId} orderStatusText={derivedOrderStatusText} />
                {/* <p className="text-[.9rem] border font-semibold border-[#E4E4E6] rounded-lg px-2 py-1">Mode: {order?.orderModeDetails?.code}</p> */}
                {product?.price_identifier === 1 && (
                  <>
                    <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1">Discount Type: Discount on PTR</p>
                    <p className="text-[.9rem]">Discount: {product?.discount_on_ptr}%</p>
                    <p className="text-[.9rem]">Order Qty. {product?.quantity}</p>
                    <p className="text-[.9rem]">Batch No: {product?.batch_number}</p>
                    {/* M10-12866 */}
                    {order?.company_code == '618' && order?.module_code == 4 &&
                      <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1 text-blue-600">
                        PO Qty: {product?.total_stockist_po_quantity}{product?.total_stockist_po_freequantity ? `+ ${product?.total_stockist_po_freequantity}` : ''}
                      </p>
                    }
                    {/* M10-12866 */}
                  </>
                )}
                {product?.price_identifier === 2 && (
                  <>
                    <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1">Discount Type: Scheme</p>
                    <p className="text-[.9rem]">
                      Scheme Qty: {product?.quantity} + {product?.free_quantity}
                    </p>

                    <p className="text-[.9rem]">Order Qty. {product?.quantity}</p>
                    <p className="text-[.9rem]">Batch No: {product?.batch_number}</p>
                    {/* M10-12866 */}
                    {order?.company_code == '618' && order?.module_code == 4 &&
                      <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1 text-blue-600">
                        PO Qty: {product?.total_stockist_po_quantity}{product?.total_stockist_po_freequantity ? `+ ${product?.total_stockist_po_freequantity}` : ''}
                      </p>
                    }
                    {/* M10-12866 */}
                  </>
                )}
                {product?.price_identifier === 3 && (
                  <>
                    <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1">Discount Type: Fixed Price</p>
                    <p className="text-[.9rem]">Fixed Price: {product?.fixed_price}</p>
                    <p className="text-[.9rem]">Order Qty. {product?.quantity}</p>
                    <p className="text-[.9rem]">Batch No: {product?.batch_number}</p>
                    {/* M10-12866 */}
                    {order?.company_code == '618' && order?.module_code == 4 &&
                      <p className="text-[.9rem] border border-[#E4E4E6] rounded-lg px-2 py-1 text-blue-600">
                        PO Qty: {product?.total_stockist_po_quantity}{product?.total_stockist_po_freequantity ? `+ ${product?.total_stockist_po_freequantity}` : ''}
                      </p>
                    }
                    {/* M10-12866 */}
                  </>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 mt-0 mr-4">
                {/* <p className="text-[.9rem]  border border-[#E4E4E6] rounded-lg px-2 py-1 font-semibold">
                  Total Billed Price: <span className="text-[#6551ff]">{totalBilledPrice.toFixed(2)}</span>
                </p>
                <p className="text-[.9rem] font-semibold">
                  Total Qty. <span className="text-[#6551ff]">{totalQuantity}</span>
                </p> */}
              </div>
              <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
                <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
              </Button>
            </div>
          </div>
          <div
            className={`overflow-hidden mt-4 transition-all duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-none" : "max-h-0 opacity-0"
              }`}
            style={{ transitionProperty: "max-height, opacity" }}
          >
            <div className="border-t border-[#d0d0d0]"></div>
            <Tab.Group>
              <div className="flex justify-between mt-6">
                <Tab.List className="flex p-[2px] space-x-1 rounded-lg bg-[#e3e3e3] w-fit h-[38px] items-center">
                  {category.map((category) => (
                    <Tab
                      key={category}
                      className={({ selected }) =>
                        classNames(
                          "w-fit px-4 rounded-md py-1.5 text-sm font-normal leading-5",
                          "focus:outline-none ",
                          selected ? "bg-white border border-[#d0d0d0] shadow-sm" : "hover:bg-white/[0.12] hover:text-black"
                        )
                      }
                    >
                      {category}
                    </Tab>
                  ))}
                </Tab.List>
              </div>
              <Tab.Panels>
                <Tab.Panel>
                  <div className="overflow-x-scroll mt-6">
                    <table className="min-w-full mt-2 border">
                      <thead className="w-full">
                        <tr>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Order Date</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Company</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Division</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">MRP</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">PTR</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Amount</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Item Discount</th>
                          <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border border-[#d0d0d0]">Batch No</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-sm">
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{moment(product?.created_date).format("Do MMMM YYYY")}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{order?.company_name}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{order?.division_name}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{product?.mrp}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{product?.ptr}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{product?.billed_price}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{product?.item_discount}</td>
                          <td className="px-4 py-1  text-[.8rem] border border-[#d0d0d0]">{product?.batch_number}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Tab.Panel>
                <div className="mt-6">
                  <Tab.Panel>
                    {groupedInvoices && Object.entries(groupedInvoices).map(([invoiceNo, items]: any) => (
                      <div key={invoiceNo}>
                        <div className="flex items-center gap-2 mt-4">
                          <p className="font-semibold text-[1rem]">
                            <span className="text-gray-400 text-[1rem]">INVOICE#</span> {invoiceNo}
                          </p>
                        </div>
                        <div className="overflow-x-scroll">
                          <table className="min-w-full mt-2 border">
                            <thead className="w-full">
                              <tr>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Invoice Date</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Supplied Qty</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">{product?.price_identifier === 1 ? "Discount on PTR" : (product?.price_identifier === 2 ? "Scheme" : "Fixed Price")}</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Batch No.</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">MRP</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PTR</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Amount</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Cash Discount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item: any) => (
                                <tr key={item?.invoice_product_order_product_id} className="text-sm">
                                  <td className="px-4 py-1 text-[.8rem] border">{moment(item?.invoiceProduct?.invoice?.new_invoice_date).format("Do MMMM YYYY")}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.quantity}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{product?.price_identifier === 1 ? item?.discount_perc : (product?.price_identifier === 2 ? item?.free_qty : item?.fixed_price)}</td> {/* M10-14422 */}
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.invoiceProduct?.batch_no}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.invoiceProduct?.inv_mrp}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.invoiceProduct?.ptr}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.invoiceProduct?.net_amt}</td>
                                  <td className="px-4 py-1 text-[.8rem] border">{item?.p_cash_discount_perc}%</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </Tab.Panel>
                  <Tab.Panel>
                    <PoGeneration company_code={order?.company_code} orderProductId={product?.order_product_id} item_code={item_code} />
                  </Tab.Panel>
                  <Tab.Panel>
                    <CNAdvice company_code={order?.company_code} orderProductId={product?.order_product_id}/>
                  </Tab.Panel>
                  <Tab.Panel>
                    <Reconcilliation
                      orderProductId={product?.order_product_id}
                      company_code={order?.company_code}
                      orderedQty={product?.quantity}
                      orderedFree={product?.free_quantity}
                      priceIdentifier={product?.price_identifier}
                    />
                  </Tab.Panel>
                </div>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OrderInfoInvoiceProducts;
